import { TSession } from '@fe-learner-common/api/schemas/sessionsSchema';
import { Tag, TagType } from '@fe-learner-common';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';

import { useIntl } from 'react-intl';
type Tag = {
  icon: IconDefinition;
  type: TagType;
  text: string;
};

type Session = Pick<TSession, 'diplomasAvailable' | 'certificatesAvailable'>;

export const useSessionTags = (
  session?: Session,
): Record<string, Tag> | null => {
  const intl = useIntl();

  if (!session) {
    return null;
  }

  let tags = {};

  if (session.diplomasAvailable) {
    tags = {
      ...tags,
      diploma: {
        icon: faGraduationCap,
        type: 'neutral',
        text: intl.formatMessage({ id: 'learner.common.diploma' }),
      },
    };
  }

  if (session.certificatesAvailable) {
    tags = {
      ...tags,
      certificate: {
        icon: faFileCertificate,
        type: 'neutral',
        text: intl.formatMessage({ id: 'learner.common.certificate' }),
      },
    };
  }

  return tags;
};
